/**
 * @module TabView
 *
 */
export { Tabs, Tab, TabList, TabPanel } from 'react-tabs';
export { default as TabView } from './TabView';
export { default as TabContent } from './TabContent';
